import Component from '@bythepixel/component-loader';

const DEFAULTS = {
  modalContainer: '[data-comp-social-share-modal]',
  copyButton: '[data-comp-copy-button]',
};

export default class SocialShareModal extends Component {
  static selector = '[data-comp-social-share-modal]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.copyButton = this.$container.querySelector(this.$options.copyButton);
    this.container = document.querySelector(this.$options.modalContainer);
    this.mount();
  }

  copyLinkToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
  }

  mount() {
    this.copyButton.addEventListener('click', this.copyLinkToClipboard);
  }
}
